module.exports = __webpack_public_path__ + "img/20.86493a9c.png";